import { Users2 } from "lucide-react";

// Iter122dh · Badge compatto mostrato accanto al nome del condòmino/fornitore quando
// il soggetto ha account autonomi presso ALTRI Studi Ginius (multi-tenant). Fornisce
// all'admin la visibilità immediata dei soggetti condivisi senza esporre nomi/dati
// degli altri tenant (privacy).
export function MultiTenantBadge({ count, testid }) {
  const n = Number(count || 0);
  if (n < 1) return null;
  const label = n === 1 ? "1 altro Studio" : `${n} altri Studi`;
  return (
    <span
      data-testid={testid || "multitenant-badge"}
      title={`Questo soggetto ha un account attivo anche presso ${label} Ginius`}
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold border border-sky-300 bg-sky-50 text-sky-800"
    >
      <Users2 className="w-3 h-3" /> anche in {label}
    </span>
  );
}
